// renameAsset — rename an asset by kind, shared by the inspector Name field and
// the content-browser inline rename (right-click → Rename). Throws for kinds
// that can't be renamed (rig — renaming would change the character slug and
// invalidate every asset URL). Prefabs/gestures carry the label in displayName;
// everything else in `name`.
import { CustomAssetManager } from './CustomAssetManager'

const RENAMEABLE = new Set([
  'prefab', 'gesture', 'material', 'texture', 'body_anim', 'face_anim', 'audio', 'environment',
  'blueprint_asset',
])

export function isRenameableAsset(asset) {
  return !!asset && RENAMEABLE.has(asset.kind)
}

export async function renameAsset(asset, newName) {
  const name = newName
  switch (asset.kind) {
    case 'prefab':      return CustomAssetManager.updatePrefab(asset.rawId, { displayName: name })
    case 'gesture':     return CustomAssetManager.updateGesture(asset.rawId, { displayName: name })
    case 'material':    return CustomAssetManager.updateMaterial(asset.rawId, { name })
    case 'texture':     return CustomAssetManager.updateTextureAsset(asset.rawId, { name })
    case 'body_anim':
    case 'face_anim':   return CustomAssetManager.updateAnimationAsset(asset.rawId, { name })
    case 'audio':       return CustomAssetManager.updateAudioAsset(asset.rawId, { name })
    case 'environment': return CustomAssetManager.updateEnvironmentAsset(asset.rawId, { name })
    // A blueprint's name is only a label — nothing references it, and which
    // blueprint LOADS is the isDefault flag, so a rename is never load-bearing.
    case 'blueprint_asset': return CustomAssetManager.updateBlueprintAsset(asset.rawId, { name })
    case 'rig':
      throw new Error("Rig renames aren't supported (would change the slug)")
    default:
      throw new Error(`Rename not wired for asset kind "${asset.kind}"`)
  }
}
